import React from 'react'
import "../header/header.css"
import "./navBar.css"



const NavBar = () => {
  return (
    <ul className='navBar'>
        <li className='navBar__intranet'>
            <a
                href='https://intranet.aysa.com.ar/'
                target='_blank'
                className='navBar__link'
            >
                AySA Intranet
            </a>
        </li>
        <span className='navBar__linea'></span>
        <li className='navBar__interrupciones'>
            <a
                href='https://www.aysa.com.ar/usuarios/Cortes-de-servicio/Cortes_de_servicio_de_agua'
                target='_blank'
                className='navBar__link'

            >
                Interrupciones
            </a>
        </li>
    </ul>
  )
}

export default NavBar
